import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { type FC } from 'react';
import { type Event } from '@/api/registration';
import { AddToCalendarButton } from 'add-to-calendar-button-react';

dayjs.extend(utc);
dayjs.extend(timezone);

interface AddToCalendarButtonProps {
  event: Event
}

const AddToCalendarComponent: FC<AddToCalendarButtonProps> = ({
  event,
}) => {
  // Doing these steps separately to avoid timezone issues
  const startDate = dayjs(event.startDate);
  const endDate = dayjs(event.endDate);
  const startTime = dayjs(event.startTime);
  const endTime = dayjs(event.endTime);

  const formattedStartDate = startDate.tz(event.tzInfoName).format('YYYY-MM-DD');
  const formattedEndDate = endDate.tz(event.tzInfoName).format('YYYY-MM-DD');
  const formattedStartTime = startTime.tz(event.tzInfoName).format('HH:mm');
  const formattedEndTime = endTime.tz(event.tzInfoName).format('HH:mm');

  return (
    <AddToCalendarButton
      hideBranding
      name={event.name}
      startDate={formattedStartDate}
      endDate={formattedEndDate}
      startTime={formattedStartTime}
      endTime={formattedEndTime}
      location={event.mapUrl}
      options={['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'Yahoo']}
      timeZone={event.tzInfoName}
      trigger="click"
      listStyle="modal"
      iCalFileName="event-reminder"
      buttonStyle={'flat'}
    />
  );
};

export default AddToCalendarComponent;
